import { useEffect, useState, useRef, useCallback } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Popup from "../../User/popup";
import { useParams } from "react-router";
import config from '../../configuration/config';
import { useHistory, useLocation } from "react-router";
import { formValidate } from '../../utils/validation';
import Joi from "joi";
import Skeleton from 'react-loading-skeleton'
import { toast } from "react-toastify";
import { Price } from "../../components/__simple/_price";
export function SparePartsSalesOrderPage() {

    let { OrderGUID } = useParams();
    const { t: trans, i18n } = useTranslation(["info", "employment", "eparts", "common", "global", "offers", "cartFile"]);
    let lang = (i18n.language || 'ar');
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const [sadadInfo, setSadadInfo] = useState(null);
    const [showFinalPopup, setShowFinalPopup] = useState(false);
    const [showFinalPopupMessage, setShowFinalPopupMessage] = useState("");
    const popRef = useRef(null);
    const [Agreements, setAgreements] = useState([]);
    const [resOrderID, setResOrderID] = useState(null);
    const history = useHistory();
    const [dataFullNum, setDataFullNum] = useState(0);
    const [isSendeng, setIsSendeng] = useState(false);
    const [paymentType, setPaymentType] = useState(null);
    const [showAgreements, setshowAgreements] = useState(false);
    const [brand, setBrand] = useState(null);
    const [Service, setService] = useState(null);
    const [showInfo, setShowInfo] = useState(true);
    const [requestForm, setRequestForm] = useState({
        name: '',
        phone: '',
        email: '',
        subject: '',
        date: '',
        time: '',
        messageContent: '',
        myCarID: '',
        SiteID: null,
        ServiceID: ''
    });

    const [platformTypes, setPlatformTypes] = useState([]);
    const [MessageError, setMessageError] = useState(null);

    useEffect(() => {

        if (Service && Service.length > 0) {

            // Dynamically load the script
            const script = document.createElement('script');
            script.src = 'https://checkout.tabby.ai/tabby-promo.js';
            script.async = true;

            script.onload = () => {
                // Ensure TabbyPromo is available globally
                if (window.TabbyPromo) {
                    new window.TabbyPromo({
                        selector: '#TabbyPromo',
                        currency: 'SAR',
                        price: Service?.reduce((total, service) => total + service.Price, 0),
                        lang: lang,
                        source: 'product',
                        publicKey: 'pk_test_20b124e0-15bd-4234-b114-17460fd843b8',
                        merchantCode: 'HJKSA',
                        // shouldInheritBg:false
                    });
                }
            };

            document.body.appendChild(script);

            // Clean up script on component unmount
            return () => {
                document.body.removeChild(script);
            };
        }

    }, [Service]);

    useEffect(() => {
        // تحميل الملف من مجلد public
        const loadManifest = async () => {
            try {
                const response = await fetch(`${process.env.PUBLIC_URL}/config.json`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                // Filter and map to extract keys with isActive = true
                var platformsTypes = data.platformsTypes || [];
                const activeKeys = platformsTypes
                    .filter((platform) => platform.isActive)
                    .map((platform) => platform.key);

                console.log("Active keys:", activeKeys);

                setPlatformTypes(activeKeys);

            } catch (error) {
                console.error("Error loading manifest.json:", error);
            }
        };

        loadManifest();
    }, []);

    const [salesOrder, setSalesOrder] = useState(null);

    const [browser, setBrowser] = useState('');

    useEffect(() => {
        const userAgent = navigator.userAgent;

        if (userAgent.indexOf('Chrome') > -1) {
            setBrowser('Chrome');
        } else if (userAgent.indexOf('Firefox') > -1) {
            setBrowser('Firefox');
        } else if (userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1) {
            setBrowser('Safari');
        } else if (userAgent.indexOf('MSIE') > -1 || userAgent.indexOf('Trident') > -1) {
            setBrowser('Internet Explorer');
        } else if (userAgent.indexOf('Edge') > -1) {
            setBrowser('Edge');
        } else {
            setBrowser('Other');
        }
    }, []);



    useEffect(() => {
        const paymentStatus = new URL(window.location.href).searchParams.get("paymentStatus");
        const orderId = new URL(window.location.href).searchParams.get("orderId");

        const paymentMethodCallback = new URL(window.location.href).searchParams.get("PaymentMethod");
        const paymentTypeCallback = new URL(window.location.href).searchParams.get("PaymentType");
        if (paymentMethodCallback != null && paymentTypeCallback != null) {

            SendAllPaymentStatus_Service_Spare(paymentMethodCallback, paymentStatus);
        } else {

            if (OrderGUID) {
                FetchSalesOrderServiceFun(OrderGUID);
            }

        }

    }, [OrderGUID])


    const Fetch_SalesInvoiceTrans = async () => {
        setService([]);
        console.log('Fetch_SalesInvoiceTrans>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
        try {
            const Body = {
                "GUID": OrderGUID
            }
            await axios.request({
                url: `${config.controllURL}${lang}/api/Pages/site_FetchTrans_SalesOrders_ServiceSpare`, data: Body, method: "POST", responseType: "json"
            })
                .then(async function (response) {
                    console.log("Fetch_SalesInvoiceTrans:", response.status);
                    if (response.status >= 200 && response.status <= 300) {

                        if (response.data != null) {
                            setService(response.data);
                        }
                    }

                })
                .catch(async function (error) {
                    // setSalesOrderStatusCode("notFound");
                    // setShowFinalPopup(true);
                    // await chickOrderStatus("notFound");
                    console.log(error);
                });
        } catch (error) {
            console.log("error:", error);
        }
    };
    useEffect(async () => {
        if (salesOrder && salesOrder.SalesInvoiceID) {
            await Fetch_SalesInvoiceTrans();
        }

    }, [salesOrder])
    async function FetchSalesOrderServiceFun(guid) {
        const Body = {
            "GUID": guid
        }

        axios.request({
            url: `${config.controllURL}${lang}/api/Pages/site_Fetch_SalesOrders_ServiceSpare`,
            data: Body, method: "POST", responseType: "json"
        })
            .then(function (response) {
                const result = response?.data;
                if (result && result.length > 0) {

                    var appData = result[0];
                    if (appData.StatusPaymentID == 'FullyPaid') {

                        const paymentMethodCallback = new URL(window.location.href).searchParams.get("PaymentMethod");
                        if (paymentMethodCallback == null) {
                            if (appData.SalesInvoiceID)
                                setResOrderID(appData.SalesInvoiceID);

                            setShowFinalPopupMessage(trans("new:Prepaid"));
                            setShowFinalPopup(true);
                        }

                    } else if (appData.SalesInvoiceStatusID == 'Canceled') {

                        const paymentMethodCallback = new URL(window.location.href).searchParams.get("PaymentMethod");
                        if (paymentMethodCallback == null) {
                            if (appData.SalesInvoiceID)
                                setResOrderID(appData.SalesInvoiceID);

                            setShowFinalPopupMessage(trans("new:agreement_link_is_cancelled"));
                            setShowFinalPopup(true);
                        }

                    } else {
                        setSalesOrder(appData);
                        // الشروط والاحكام
                        let dataTerms;
                        if ((appData.TermsConditionsAr != null && appData.TermsConditionsAr != '') || (appData.TermsConditionsEn != null && appData.TermsConditionsEn != '')) {
                            let termBefore = lang == 'ar' ? appData.TermsConditionsAr : appData.TermsConditionsEn;
                            let termAfter = termBefore.toString().replaceAll("\\n", "\n").split('\n');
                            dataTerms = termAfter;

                            setAgreements(dataTerms);
                        }

                    }
                } else {
                    setShowFinalPopupMessage(trans("امر البيع غير موجود"));
                    setShowFinalPopup(true);
                }
            })
            .catch(function (error) {

                console.log(error);

            });


    }


    useEffect(() => {

        function handleClickOutside(event) {
            if (popRef.current && !popRef.current.contains(event.target) && showFinalPopup === true) {
                setShowFinalPopup(false);
                setResOrderID(null);
                if (location.pathname)
                    history.push(location.pathname);

            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showFinalPopup]);


    //--------------------------------------------------
    const [maintenanceObj, setMaintenanceObj] = useState({
        showPopup: false, type: "Notset", main: "", sub1: "", sub2: ""
    });
    const [Defult, setDefult] = useState({
        showPopup: false, type: "Notset", main: "", sub1: "", sub2: ""
    });



    const notLoginSchema = Joi.object({
    });

    useEffect(() => {

        try {

            if (requestForm?.date) {

                var md = new Date(requestForm?.date);
                try {
                    if (requestForm?.time) {

                        var Hours = requestForm?.time.split(":");

                        md.setHours(Hours[0], Hours[1], 0);
                    }
                } catch (error) {

                }


            }

        } catch (error) {
        }


    }, [requestForm]);

    const [Note, setNote] = useState("");
    //---------------------

    const [error, setError] = useState({});
    async function SendResreve() {

        const val = { ...requestForm };
        setRequestForm(val);
        const result = formValidate(notLoginSchema, val) ?? {};
        setError(result);
        if (Object.keys(result).length == 0 && isSendeng == false) {

            let listofServices;

            Service.map((item) => {

                if (listofServices)
                    listofServices += "," + item;
                else
                    listofServices = item;
            });
            setMessageError(null);
            setIsSendeng(true);
            try {
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                var raw = {
                    "paytype": paymentType,
                    "OrderGUID": OrderGUID,
                    "servicelist": listofServices,
                    "callback": window.location.origin + "/" + lang + `/maintenance/SparePartsSalesOrder/${OrderGUID}`
                };

                console.log("raw>>>>>>>>>>>>>>>>:", raw);

                await axios.request({
                    baseURL: config.controllURL,
                    url: "api/Payment/SendApprovedPayment_Service_Spare",
                    headers: myHeaders,
                    data: raw, method: "POST", responseType: "json"
                })

                    .then(async response => {
                        console.log('Payment respons data:\n', response.data);


                        if (response.data.URL_Paytabs) {
                            window.location.href = response.data.URL_Paytabs;

                        } else if (response.data.url_payment) {
                            window.location.href = response.data.url_payment;
                            //site_fetchSadadCode_salesOrdersService
                        } else {
                            setIsSendeng(false);
                            if (response?.data?.MessageError) {

                                if (paymentType == 'tabby') {
                                    setMessageError(response.data.MessageError);
                                } else {
                                    toast.error(response?.data?.MessageError);
                                }


                            }

                            else
                                toast.error(trans("error:unknown_failure"));
                        }

                        setIsSendeng(false);
                    })
                    .catch(function (error) {

                        setIsSendeng(false);
                    });

            } catch (error) {
                setIsSendeng(false);

                console.log("error:", error);
            }

        }
    }



    async function StatusPaymentTamaraSalesOrdersService(orderId) {
        console.log('StatusPaymentTamaraSalesOrdersService >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');

        if (OrderGUID && orderId) {



            try {
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                var raw = {
                    "GUID": OrderGUID,
                    "orderId": orderId ?? ""
                };

                await axios.request({
                    baseURL: config.controllURL,
                    url: "api/Payment/StatusPaymentTamaraSalesOrdersService",
                    headers: myHeaders,
                    data: raw, method: "POST", responseType: "json"
                }).then(async response => {
                    console.log('StatusPaymentTamaraSalesOrdersService respons:', response);
                    if (response.data) {

                        var data = response.data;
                        console.log('PaymentPaytabsStatusFully data:', data);
                        if (data.Status == "success") {
                            setShowFinalPopup(true);
                            if (data.OrderId)
                                setResOrderID(data.OrderId);
                        }
                    }


                }
                ).catch(async error => {
                    console.log('error StatusPaymentTamaraSalesOrdersService:', error)

                });
            } catch (error) {
                console.log('error', error)


            }
        }
    }

    async function SendAllPaymentStatus_Service_Spare(paymentMethodCallback, paymentStatus) {
        console.log('StatusPaymentMyfatoorahSalesOrdersService >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>:', paymentMethodCallback);
        console.log('StatusPaymentMyfatoorahSalesOrdersService >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>:', paymentStatus);
        console.log('StatusPaymentMyfatoorahSalesOrdersService >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>:', OrderGUID);

        if (paymentMethodCallback == 'myFatoorah' || paymentMethodCallback == 'paytabs' || paymentMethodCallback == 'tabby'
            || paymentMethodCallback == 'sadad'
        ) {

        } else if (paymentMethodCallback == 'tamara' && paymentStatus == 'approved') {
            setShowFinalPopup(true);
        } else {
            setIsSendeng(false);
            toast.error(trans("error:unknown_failure"));

            return;
        }
        if (OrderGUID) {



            try {
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                var raw = {
                    "paytype": paymentMethodCallback,
                    "OrderGUID": OrderGUID,
                };

                await axios.request({
                    baseURL: config.controllURL,
                    url: "api/Payment/SendAllPaymentStatus_Service_Spare",
                    headers: myHeaders,
                    data: raw, method: "POST", responseType: "json"
                }).then(async response => {
                    console.log('PaymentMyfatoorahStatusFully respons:', response);
                    if (response.data) {
                        var data = response.data;
                        if (response.data.length > 0) {
                            data = response.data.filter(p => p.Status == "success")[0];
                        }

                        console.log('PaymentMyfatoorahStatusFully data:', data);
                        if (data.Status == "success") {
                            setShowFinalPopup(true);
                            if (data.OrderId)
                                setResOrderID(data.OrderId);
                        }
                    }

                }
                ).catch(async error => {
                    console.log('error PaymentMyfatoorahStatusFully:', error)

                }).finally(() => {
                    FetchSalesOrderServiceFun(OrderGUID);
                });
            } catch (error) {
                console.log('error', error)
                FetchSalesOrderServiceFun(OrderGUID);
            }
        }
    }


    useEffect(() => {

        if (salesOrder && salesOrder.length > 0) {
            setRequestForm({
                ...requestForm,
                name: lang == "ar" ? salesOrder.CustNameAr : salesOrder.CustNameEn,
                phone: salesOrder.Mobile,
                email: salesOrder.Email,
                myCarID: salesOrder.VIN
            });

        }

    }, [salesOrder])

    const formatDateTime = useCallback((date, currentformat = null) => {
        try {
            if (date) {
                let dateNow = new Date(date)
                var formatDate;

                if (currentformat) {

                    formatDate = currentformat;
                } else {
                    formatDate = {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true
                    }

                }


                if (lang.language === 'en') {
                    return dateNow.toLocaleDateString('en-US', formatDate)
                } else {
                    return dateNow.toLocaleDateString('en-US', formatDate)
                }
            } else {
                return date
            }
        } catch (error) {
            console.log(error)
            return date
        }
    }, [])

    const checkDataFullNum = async () => {

        if (paymentType && Service && Service.length > 0) {

            setDataFullNum(2);
            return 2;
        } else if (paymentType && Service && Service.length > 0) {

            setDataFullNum(2);
            return 2;
        } else {
            setDataFullNum(0);
            return 0;
        }


    }

    useEffect(() => {
        checkDataFullNum();
    }, [Service, paymentType]);
    return (
        <>

            {
                (salesOrder) ?

                    <div className={"protection-and-shading   " + (brand == 1 ? " toyota-theme " : " lexus-theme ")} >

                        <div className="protection-and-shading-head" >
                            <div className="protection-and-shading-head-Logo">

                                {
                                    lang == "ar" ?

                                        <div className="res-Logo-icon ">
                                            <img src="/assets/logo/logo_font_Black_AR.svg"
                                                alt="hassan jameel" className="hidden d-md-inline" />
                                            <img src="/assets/logo/logo_font_Black_AR.svg"
                                                alt="hassan jameel" className="d-inline d-md-hidden" />
                                        </div>


                                        :

                                        <div className="res-Logo-icon ">
                                            <img src="/assets/logo/logo_font_Black_EN.svg"
                                                alt="hassan jameel" className="hidden d-md-inline" />
                                            <img src="/assets/logo/logo_font_Black_EN.svg"
                                                alt="hassan jameel" className="d-inline d-md-hidden" />
                                        </div>
                                }
                            </div>

                            <div className="protection-and-shading-head-extra flex flex-worp">
                                <div className="protection-and-shading-head-brand flex flex-worp">
                                    {
                                        (brand == 1) ?
                                            <>
                                                <img src={`/assets/icons/brands/${"toyota-logo-withName.png"}`}
                                                    className="" alt={brand} />
                                            </>
                                            :
                                            (
                                                (brand == 2) ?
                                                    <>
                                                        <img src={`/assets/icons/brands/${"lexus-logo-withName.png"}`}
                                                            className="" alt={brand} />
                                                    </>
                                                    :
                                                    null

                                            )

                                    }
                                </div>

                                <button
                                    onClick={() => {

                                        if (window.location.href.includes("/ar") || window.location.href.includes("/en")) {

                                            if (window.location.href.includes("/en"))
                                                window.location = window.location.href.replace("/en", "/ar");
                                            if (window.location.href.includes("/ar"))
                                                window.location = window.location.href.replace("/ar", "/en");

                                        } else {

                                            window.location = window.location.origin + "/en" + window.location.pathname;
                                        }
                                    }}
                                    className="protection-and-shading-top-lang h-full  flex justify-center items-center">

                                    <span className='text-white font-bold pl-2 pr-2 capitalize'>{trans('common:changeLangCode')}</span>
                                    <img src="/assets/icons/globle.svg" alt="change language" />
                                </button>
                            </div>


                        </div >


                        {/*   */}
                        <div className="rounded-b-3xl border-b-4 border-gray-300 mb-20 transition-all duration-500 ease-in-out nice-container flex flex-col nice-gap-1rem cart-item-radius bg-white">


                            <div className="protection-and-shading-titel nice-container nice-relative">
                                <div className=" p-4">
                                    <div className="mainteance-popup-container-header py-5 flex flex-col ">
                                        <h3 className="text-balck text-bold text-40 my-5 ">
                                            {trans("info:قطع الغيار")}</h3>
                                    </div>


                                </div>

                            </div >



                            <div className="flex flex-row nice-gap-1rem mt-20">
                                <span
                                    className="text-30 text-bold text-nowrap text-capitalize"> {trans('new:invoice_number_mt')}: </span>
                                <span className="text-30 text-bold"> {salesOrder.SalesInvoiceID} </span>
                            </div>

                            <div className="flex flex-row nice-gap-1rem">
                                <span className="text-30 text-nowrap text-capitalize"> {trans('new:name')}: </span>
                                <span className="text-30 ">
                                    {lang == 'ar' ? salesOrder.DescriptionAr : salesOrder.DescriptionEn}
                                </span>
                            </div>
                            {
                                salesOrder?.Mobile != null
                                    ? <div className="flex flex-row nice-gap-1rem">
                                        <span className="text-30 text-nowrap text-capitalize">
                                            {trans('new:mobile')}:
                                        </span>
                                        <span className="text-24 text-bold text-info-light language-en" dir="ltr">
                                            <a
                                                className="text-30 text-bold text-info-light language-en border-line-b"
                                                href={'tel:' + salesOrder?.Mobile}
                                            >
                                                {salesOrder?.Mobile}
                                            </a>
                                        </span>
                                    </div> : <></>
                            }
                            <div className="flex flex-row nice-gap-1rem">
                                <span className="text-30 text-nowrap text-capitalize">
                                    {trans('new:date_time')}:
                                </span>
                                <span className="text-30 language-en">
                                    {salesOrder.SalesInvoiceDate != null ? formatDateTime(salesOrder.SalesInvoiceDate) : ""}
                                </span>
                            </div>

                            <div className="flex flex-row nice-gap-1rem">
                                <span className="text-30 text-nowrap text-capitalize">
                                    {trans('new:Spare_parts_consultant')}:
                                </span>
                                <span className="text-30 language-en">
                                    {lang == 'ar' ? salesOrder.ConsultantAr : salesOrder.ConsultantEn}
                                </span>
                            </div>

                            <div className="flex flex-row nice-gap-1rem">
                                <span className="text-30 text-nowrap text-capitalize">
                                    {trans('new:mobile')}:
                                </span>
                                <span className="text-24 text-bold text-info-light language-en" dir="ltr">
                                    <a className="text-30 text-bold text-info-light language-en border-line-b"
                                        href={'tel:' + salesOrder?.MobileConsultant}
                                    >
                                        {salesOrder.MobileConsultant}
                                    </a>
                                </span>
                            </div>

                            {/*         */}
                            {
                                // showInfo
                                //     ? (
                                <div className={`transition-all duration-500 ease-in-out overflow-hidden ${showInfo ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}>
                                    <div className="mt-20 space-y-4">
                                        {/* العنوان الرئيسي */}
                                        <div className="text-30 font-bold capitalize underline">
                                            {trans('new:spare_parts_required')}
                                        </div>

                                        {/* رأس الجدول */}
                                        <div className="grid grid-cols-3 gap-x-4 bg-gray-100 text-gray-800 rounded-md p-3 font-bold text-30 capitalize shadow-sm"
                                             style={{borderBottom: "0.2rem solid #656565"}}>
                                            <div className="text-30 font-bold">{trans("new:description")}</div>
                                            <div className="text-30 font-bold text-center">{trans("new:qty")}</div>
                                            <div className="text-30 font-bold text-center">{trans("new:total")}</div>
                                        </div>

                                        {/* المحتوى */}

                                        <div className="space-y-2">
                                            {
                                                Service?.map((item, index) => (
                                                    <div key={index}
                                                         className="grid grid-cols-3 gap-x-4 capitalize"
                                                         style={{padding: "0.8rem 0.5rem", borderBottom: "0.1rem solid #E5E5E5"}}>
                                                        <div className="text-30">{lang === 'en' ? item.Description : item.DescriptionAr}</div>
                                                        <div className="text-30 font-bold text-center">{item.Qty}</div>
                                                        <div className="text-30 font-bold text-center">
                                                            <Price price={item.NetTotalBeforeDisc} showZero={true} />
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>

                                // )
                                // : (
                                //     <>
                                //         <div className="flex flex-row nice-gap-1rem">
                                //             <span
                                //                 className="text-40 text-bold text-nowrap text-capitalize text-underline">
                                //             </span>
                                //         </div>
                                //     </>
                                // )
                            }

                            {/*  show  */}
                            {

                                <div className="flex flex-col items-center  mt-5 p-10"
                                    onClick={() => {
                                        setShowInfo(!showInfo);
                                    }}>
                                    {
                                        //                                 <div className={`
                                        //   transition-all duration-500 ease-in-out
                                        //   ${show ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}
                                        //   ${show ? 'pointer-events-auto' : 'pointer-events-none'}
                                        // `}>


                                        (showInfo == true) ? (
                                            <>
                                                <span
                                                    className="text-20 my-10 text-capitalize">{trans("new:hide_varieties_mt")}</span>
                                                <img src="/assets/icons/arrow-down.svg"
                                                    className="object-contain rotate-180" alt="" />
                                                <img src="/assets/icons/arrow-down.svg"
                                                    className="object-contain rotate-180" alt="" />
                                            </>
                                        ) :
                                            (
                                                <>
                                                    <span
                                                        className="text-20 my-10 text-capitalize">{trans("new:show_varieties_mt")}</span>
                                                    <img src="/assets/icons/arrow-down.svg" className="object-contain" alt="" />
                                                    <img src="/assets/icons/arrow-down.svg" className="object-contain" alt="" />
                                                </>
                                            )

                                        // </div>
                                    }
                                </div>
                            }

                            {/*  butom  */}
                        </div>


                        <div className="cart-container bg-light cart-item-radius-top">
                            <section className="cart-bill bg-white nice-container">

                                <div className="flex flex-row justify-between items-center"
                                     style={{padding: "1.2rem 0.5rem", borderBottom: "0.1rem solid #E5E5E5"}}>
                                    <span className="text-30 font-bold text-black">
                                        {trans("new:discount")}
                                    </span>
                                    <span className="text-30 font-bold text-black">
                                        <Price price={salesOrder?.DiscountTotal} showZero={true} />
                                    </span>
                                </div>

                                <div className="flex flex-row justify-between items-center"
                                     style={{padding: "1.2rem 0.5rem", borderBottom: "0.1rem solid #E5E5E5"}}>
                                    <span className="text-30 font-bold text-black">
                                        {trans('info:amount')}
                                    </span>
                                    <span className="text-30 font-bold text-black">
                                        <Price price={salesOrder?.NetTotalExclTax} />
                                    </span>
                                </div>

                                <div className="flex flex-row justify-between items-center"
                                     style={{padding: "1.2rem 0.5rem", borderBottom: "0.1rem solid #E5E5E5"}}>
                                    <span className="text-30 font-bold text-black">
                                        {trans("new:tax_value") + " (15%) "}
                                    </span>
                                    <span className="text-30 font-bold text-black">
                                        <Price price={salesOrder?.TotalTax} />
                                    </span>
                                </div>

                                {/* الاجمالي */}
                                <div className="flex flex-row justify-between items-center bg-black border-radius my-10"
                                     style={{padding: "1.8rem 2rem", color: "#ffffff"}}>
                                    <div className="flex flex-col" style={{color: "#ffffff"}}>
                                        <span className="text-30 font-bold" style={{color: "#ffffff"}}>
                                            {trans("new:total")}
                                        </span>
                                        <span className="text-16" style={{color: "#ffffff", opacity: 0.85, fontWeight: 400}}>
                                            {trans("new:total_include_tax")}
                                        </span>
                                    </div>
                                    <span className="text-40 font-bold"
                                          style={{color: "#ffffff", whiteSpace: "nowrap"}}>
                                        {salesOrder?.NetTotalAfterDisc != null && salesOrder?.NetTotalAfterDisc !== "" ? (
                                            <i className="icon-icomoon-Saudi_Riyal_Symbol-2"
                                               style={{color: "#ffffff"}}>
                                                {new Intl.NumberFormat('en-US').format(parseFloat(salesOrder.NetTotalAfterDisc))}
                                            </i>
                                        ) : null}
                                    </span>
                                </div>

                            </section>
                        </div>

                        <div className="my-20 py-5  bg-gray-lighter ">
                            <div className="flex flex-col nice-gap-2rem nice-container ">
                                <div className="flex flex-row justify-between items-center nice-container">
                                    <h3 className="text-30 font-bold text-black"> {trans("new:pay_method")}</h3>

                                </div>
                                <div className="breakout!! flex flex-col nice-gap-2rem ">
                                    {
                                        platformTypes && platformTypes.includes("payTabs") &&
                                        <div className={"flex flex-col nice-gap-2rem border-radius p-5 " + (paymentType == "payTabs" ? " bg-gray-light " : "")}
                                            onClick={() => {
                                                setPaymentType("payTabs");
                                            }}
                                        >
                                            <label className={" text-20 font-bold flex flex-row nice-gap-1rem "}>
                                                <input type='radio' checked={paymentType == "payTabs" ? true : false} name='paymentType'


                                                    onChange={() => {



                                                    }}
                                                    id="primary"
                                                />
                                                {trans("new:online_all")}

                                            </label>
                                            <div className="flex flex-row items-center  mx-10">
                                                <img className="cart-payment-icon object-contain" src="/assets/icons/companies/master-card-3.png" alt={"master"} />
                                                <img className="cart-payment-icon object-contain" src="/assets/icons/companies/visa-3.png" alt={"visa"} />
                                                <img className="cart-payment-icon object-contain" src="/assets/icons/companies/mada-3.png" alt={"mada"} />

                                            </div>

                                        </div>


                                    }

                                    {
                                        platformTypes && platformTypes.includes("myfatoorah") &&
                                        <div className={"flex flex-col nice-gap-2rem border-radius p-5 " + (paymentType == "myfatoorah" ? " bg-gray-light " : "")}
                                            onClick={() => {
                                                setPaymentType("myfatoorah");
                                            }}
                                        >
                                            <label className={" text-20 font-bold flex flex-row nice-gap-1rem "}>
                                                <input type='radio' checked={paymentType == "myfatoorah" ? true : false} name='paymentType'


                                                    onChange={() => {



                                                    }}
                                                    id="primary"
                                                />
                                                {trans("new:online_all")}

                                            </label>
                                            <div className="flex flex-row items-center  mx-10">
                                                <img className="cart-payment-icon object-contain" src="/assets/icons/companies/master-card-3.png" alt={"master"} />
                                                <img className="cart-payment-icon object-contain" src="/assets/icons/companies/visa-3.png" alt={"visa"} />
                                                <img className="cart-payment-icon object-contain" src="/assets/icons/companies/mada-3.png" alt={"mada"} />

                                            </div>

                                        </div>


                                    }

                                    {
                                        platformTypes && platformTypes.includes("tamara") &&
                                        <div className={"flex flex-col  border-radius p-5  " + (paymentType == "tamara" ? " bg-gray-light  " : "")}
                                            onClick={() => {

                                                setPaymentType("tamara");
                                            }}
                                        >
                                            <label className={" text-20 font-bold flex flex-row nice-gap-1rem "}>
                                                <input type='radio' checked={paymentType == "tamara" ? true : false}
                                                    name='paymentType'

                                                    onChange={() => {
                                                        console.log("<< PaymentType >>: ", paymentType);
                                                    }}

                                                    id="primary"

                                                />

                                                {trans("new:byTamara")}

                                                <div className="flex flex-row  cart-payment-icon">
                                                    <img className="cart-payment-icon object-contain"
                                                        src={lang == 'ar'
                                                            ? "/assets/icons/AR-tamara.svg"
                                                            : "/assets/icons/En-tamara.svg"}
                                                        alt={""} />
                                                </div>

                                            </label>
                                            <label className={" text-20  flex flex-row  pr-20 pl-20"}>
                                                {trans("new:byTamara3")}
                                            </label>
                                            <label className={" text-20  flex flex-row pr-20 pl-20 "}>
                                                {trans("new:byTamara4")}
                                            </label>
                                        </div>

                                    }

                                    {
                                        platformTypes && platformTypes.includes("tamara") &&
                                        <div
                                            className={"flex flex-col nice-gap-1rem  p-5 " + (paymentType == "tabby" ? "bg-gray-light my-10" : "")}>
                                            <label
                                                className={" text-20 text-bold  flex flex-row nice-gap-1rem  pl-10  items-center"}>
                                                <input type='radio' checked={paymentType == "tabby" ? true : false} name='paymentType'
                                                    onClick={() => {

                                                        setPaymentType("tabby");
                                                    }}
                                                    onChange={() => {

                                                    }}

                                                    id="primary"

                                                // disabled={checkTamarClose === true ? true : false}
                                                />


                                                {lang == "ar" ? "قسّمها على 4 دفعات ,بدون فوائد أو رسوم" : "Pay in 4. No interest, no fees"}

                                                <div className="flex flex-row  ">
                                                    <img className="cart-payment-icon object-contain"
                                                        src={lang == 'ar'
                                                            ? "/assets/icons/tabby.png"
                                                            : "/assets/icons/tabby.png"}
                                                        alt={""}
                                                    // onError={"/assets/icons/companies/tabby.jpeg"}
                                                    />
                                                </div>

                                            </label>
                                            <div id="TabbyPromo"></div>

                                            {
                                                MessageError &&
                                                <div className='language-en  nice-border text-bold flex border-error flex-col nice-gap-1rem  p-10  my-10 text-error text-20'
                                                    style={{ backgroundColor: "#ffe6e3" }}
                                                >{MessageError}</div>
                                            }

                                        </div>

                                    }

                                    {
                                        platformTypes && platformTypes.includes("sadad") &&
                                        <div className={"flex flex-col nice-gap-2rem border-radius p-5  " + (paymentType == "sadad" ? " bg-gray-light  " : "")}
                                            onClick={() => {

                                                setPaymentType("sadad");
                                            }}
                                        >
                                            <label className={" text-20 font-bold flex flex-row  items-center nice-gap-1rem "}>
                                                <input type='radio' checked={paymentType == "sadad" ? true : false} name='paymentType'

                                                    onChange={() => {

                                                    }}
                                                    id="primary"
                                                />
                                                <img className=" object-contain"
                                                    src={"/assets/icons/companies/SADAD-Logo.png"} width={"60px"} alt={"SADAD"} />

                                            </label>


                                        </div>

                                    }

                                </div>
                            </div>
                        </div>

                        <ul className="reservation-privacy-link nice-container my-10">
                            {

                                <li className="text-balck text-bold text-24 text-center">
                                    <a className={"text-16 nice-pointer"}
                                        // href="/protectionAndShadingAgreement"
                                        onClick={(e) => {
                                            // e.defaultPrevented();
                                            setshowAgreements(true)
                                        }}
                                    >{trans('offers:terms')}</a>
                                </li>
                            }

                        </ul>

                        <div className="ruler-2 mb-3"></div>
                        {

                            <div className=" nice-container">
                                {

                                    <div className="flex flex-row nice-gap-2rem my-20  ">

                                        {
                                            browser && browser == "Safari" ?
                                                <div className=" w-100 mb-5 "
                                                    onClick={() => {

                                                        if (dataFullNum >= 2 && isSendeng == false)
                                                            SendResreve();

                                                    }}

                                                >
                                                    <div title="" className={"nice-style-btn nice-flex-row py-3  text-white text-20 " + (dataFullNum >= 2 ? " bg-black" : " bg-gray ")}
                                                    >
                                                        {
                                                            isSendeng && <span className='mx-2 loading-btn '>
                                                                <img className="object-max-full " alt="" src='/assets/icons/loading.svg' width='25' height='25' />
                                                            </span>
                                                        }
                                                        <img className="object-max-full" src="/assets/icons/apple-pay.png" alt="apple-pay" width='70' height='70' />
                                                    </div>
                                                </div>

                                                :


                                                <div className="w-100  mb-5">
                                                    <div className={"nice-bg-btn  text-white text-24 " + (dataFullNum >= 2 ? " bg-primary " : " bg-gray ")}
                                                        onClick={() => {


                                                            if (dataFullNum >= 2 && isSendeng == false)
                                                                SendResreve();

                                                        }}>
                                                        {

                                                            trans("cartFile:comlete_buying")

                                                        }

                                                        {
                                                            isSendeng && <span className='mx-2 loading-btn '>
                                                                <img className="object-max-full " alt="" src='/assets/icons/loading.svg' width='25' height='25' />
                                                            </span>
                                                        }

                                                    </div>
                                                </div>

                                        }




                                    </div>



                                }

                            </div>
                        }



                    </div >

                    :
                    <>
                        <Skeleton count={1} borderRadius={"2rem"} width={"100%"} height={"20rem"}
                            containerClassName={""} className={"my-5"}
                            inline={true} />

                        <Skeleton count={3} borderRadius={"2rem"} width={"80%"} height={"5rem"}
                            containerClassName={"flex flex-col"} className={"my-5"}
                            inline={true} />

                        <Skeleton count={3} borderRadius={"2rem"} width={"30%"} height={"10rem"}
                            containerClassName={" flex justify-center items-center"} className={"my-5"}
                            inline={false} />
                        <Skeleton count={4} borderRadius={"2rem"} width={"100%"} height={"5rem"}
                            containerClassName={""} className={"my-5"}
                            inline={true} />
                        <Skeleton count={2} borderRadius={"2rem"} width={"100%"} height={"40rem"}
                            containerClassName={""} className={"my-5"}
                            inline={true} />
                        <Skeleton count={1} borderRadius={"2rem"} width={"100%"} height={"10rem"}
                            containerClassName={""} className={"my-5"}
                            inline={true} />

                    </>

            }

            <Popup show={showFinalPopup}>
                <div className="w-full h-full flex flex-column justify-center items-center" >
                    <div className="cart-finalized" >
                        <div className="cart-finalized-container flex flex-col">

                            <div className="cart-finalized-container-img flex flex-col">
                                <img src="/assets/images/finalized.svg" alt="" />
                            </div>

                            <div className="flex flex-wrap justify-center">
                                <span className="text-20 font-bold text-black mx-2 unselectable ">{trans("new:thank_to_choose")}</span>
                                <span className="text-20 font-bold text-primary mx-2"> {trans("new:HJ_cars")}</span>
                            </div>

                            {
                                showFinalPopupMessage &&
                                <>
                                    <div className="flex flex-wrap justify-center mx-20">
                                        <span className="text-20 font-bold  mx-2"> {showFinalPopupMessage}</span>
                                    </div>

                                </>

                            }
                            {

                                <>

                                    {

                                        resOrderID &&
                                        <div className="flex flex-row justify-center cart-finalized-code"
                                            onClick={() => {

                                                navigator.clipboard.writeText(resOrderID);
                                            }}

                                        >

                                            <span className="text-20 font-bold text-white  mx-2"> {trans("info:order-number") + " :"}</span>
                                            <span className="text-20 font-bold text-white  mx-2">{resOrderID && resOrderID}</span>
                                            <img src="/assets/icons/copy.svg" alt='' />
                                        </div>
                                    }
                                    
                                </>

                            }
                            <div className="flex flex-center flex-col  mt-5 pt-5 w-80">
                                <div className=" mb-5 w-100">
                                    <div className="nice-sm-btn cart-notification-go  bg-primary text-white text-16" onClick={() => {

                                        setShowFinalPopup(false);
                                        setResOrderID(null);
                                        if (location.pathname)
                                            history.push("/");

                                    }}>
                                        {trans("cartFile:Continue_browsing")}
                                    </div>
                                </div>
                            </div>


                        </div>

                    </div>

                </div>
            </Popup>

            <Popup show={showAgreements}>

                <div
                    onClick={() => setshowAgreements(false)}
                    style={{
                        position: "fixed",
                        inset: 0,
                        background: "rgba(0,0,0,0.6)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 10002,
                        padding: "2rem",
                    }}>
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            position: "relative",
                            background: "#fff",
                            borderRadius: "1.6rem",
                            width: "min(90vw, 70rem)",
                            maxHeight: "85vh",
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                            boxShadow: "0 1.6rem 4rem rgba(0,0,0,0.25)",
                        }}>
                        <div style={{
                            position: "relative",
                            padding: "2rem 2rem 1rem 2rem",
                            borderBottom: "0.1rem solid #E5E5E5",
                        }}>
                            <h1 className="text-balck text-bold text-24 text-center">{trans("offers:terms")}</h1>
                            <span
                                className='nice-select-none nice-pointer'
                                onClick={() => setshowAgreements(false)}
                                style={{
                                    position: "absolute",
                                    top: "1rem",
                                    insetInlineEnd: "1.5rem",
                                    fontSize: "3rem",
                                    lineHeight: "1",
                                    fontWeight: "bold",
                                    color: "var(--primary)",
                                    cursor: "pointer",
                                    zIndex: 2,
                                }}
                                aria-label="close"
                            >×</span>
                        </div>
                        <div style={{flex: 1, overflowY: "auto", padding: "1rem 2rem 2rem 2rem"}}>
                            <div className="mx-10 my-10">

                                {
                                    Agreements && Agreements.length > 0 ?
                                        <div className={"new-lines "}>
                                            <ul className={"text-20 my-10 mx-10 leading-relaxed"}>
                                                {

                                                    Agreements?.map((term, index) => {
                                                        return (

                                                            term &&
                                                            <li key={index} className={"text-30  my-5 "}>
                                                                {
                                                                    !term.includes("<>") &&
                                                                    <>
                                                                        <span className="text-30 text-bold ">{term}</span>
                                                                    </>
                                                                }

                                                                {
                                                                    term.includes("<>") &&
                                                                    term.split('<>').slice(1).map((termsub, indexsub) => {
                                                                        return (
                                                                            termsub &&
                                                                            <h6 key={indexsub} className="text-30 text-bold ">{"-"} <span
                                                                                className="text-30 text-bold ">{termsub}</span></h6>

                                                                        );
                                                                    })
                                                                }
                                                            </li>
                                                        );
                                                    })
                                                }
                                            </ul>

                                        </div>
                                        : null
                                }

                            </div>

                            <div className="ruler-2 mb-3"></div>
                        </div>
                    </div>
                </div>
            </Popup>


        </>
    );
}